module.exports = __webpack_public_path__ + "img/logo_cap_innove.e056751f.png";